import React from "react";
import {Pagination} from "antd";
import PropTypes from "prop-types";

import styles from "./style/Pagination.less";

export default class CustomPagination extends React.Component {
    static defaultProps = {
        prefixCls: "renyuan-pagination",
        showTotal: (total) => {
            return `共${total}条`;
        },
        size: "small",
        showSizeChanger: false,
    };

    static propTypes = {
        prefixCls: PropTypes.oneOf(["renyuan-pagination"]),
        showTotal: PropTypes.func,
        size: PropTypes.oneOf(["small", "default"]),
        showSizeChanger: PropTypes.bool,
    };

    render() {
        const {prefixCls, showTotal, size, showSizeChanger, ...restProps} = this.props;

        return (
            <div
                style={{
                    marginTop: 14,
                }}
            >
                <Pagination
                    className={styles[prefixCls] ?? ""}
                    size={size}
                    showTotal={showTotal}
                    showSizeChanger={showSizeChanger}
                    {...restProps}
                />
            </div>
        );
    }
}
